import { Box, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// Icons
import EditIcon from "@mui/icons-material/Edit";
import { Info } from "@mui/icons-material";
import ViewModuleIcon from "@mui/icons-material/ViewModule";

function ConectionCard({ kabel, setKabelId, setOpenDialog, setDialogVersion, setEditDisabled }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const editAction = (id) => {
    setEditDisabled(false);
    setDialogVersion(0);
    setOpenDialog(true);
    setKabelId(id);
  };

  const editActionInfo = (id) => {
    setDialogVersion(1);
    setEditDisabled(true);
    setOpenDialog(true);
    setKabelId(id);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          padding: 1,
          paddingTop: 4,
          gap: 4,
          width: "100%",
        }}
      >
        {/* Linkes Gerät */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              border: "3px solid",
              borderColor: "text.primary",
              borderRadius: 1,
            }}
          ></Box>
        </Box>

        {/* Verbindung */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mt: 2.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
              }}
            >
              {kabel.ID}
            </Typography>
            <Tooltip title={t("Bearbeiten")}>
              <IconButton sx={{ marginTop: -1 }} onClick={() => editAction(kabel.ID)} color="primary">
                <EditIcon />
              </IconButton>
            </Tooltip>
          </Box>

          <Box
            sx={{
              width: "100%",
              height: "28px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <svg
              style={{
                width: "100%",
                height: "100%",
              }}
            >
              <defs>
                <marker id="arrow" markerWidth="8" markerHeight="8" refX="4" refY="4" orient="auto">
                  <path d="M0,0 L8,4 L0,8" fill="none" stroke="currentColor" strokeWidth="1.5" />
                </marker>
              </defs>

              <line x1="5%" y1="50%" x2="95%" y2="50%" stroke="currentColor" strokeWidth="2" markerStart="url(#arrow)" markerEnd="url(#arrow)" />
            </svg>
          </Box>
        </Box>

        {/* Rechtes Gerät */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              border: "3px solid",
              borderColor: "text.primary",
              borderRadius: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Tooltip title={t("Geräteinfos laden")}>
              <IconButton onClick={() => navigate(`/KMPAPI/device/${kabel.zielLHRR}`)} color="primary">
                <ViewModuleIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
        }}
      >
        <Box sx={{ width: "45%", justifyContent: "center" }}>
          <Typography>{kabel.startEinheit}</Typography>
          <Typography>{kabel.startGeraet}</Typography>
          <Typography>{kabel.startPort}</Typography>
        </Box>

        <Box sx={{ width: "45%", justifyContent: "center" }}>
          <IconButton onClick={() => editActionInfo(kabel.ID)} color="primary">
            <Info />
          </IconButton>
        </Box>

        <Box sx={{ width: "45%", justifyContent: "center" }}>
          <Typography>{kabel.zielEinheit}</Typography>
          <Typography>{kabel.zielGeraet}</Typography>
          <Typography>{kabel.zielPort}</Typography>
        </Box>
      </Box>

      <Divider component="li" />
    </Box>
  );
}

export default ConectionCard;
